module.exports = __webpack_public_path__ + "media/images/flags/mm-89b07e7fad5bd94662fe714bd9e30251.svg";